import { FabProps, Theme, withStyles, Chip, ChipProps } from '@material-ui/core';
import { forwardRef } from 'react';
import { ColoredCommonProps } from './common';

type ColoredChipIconButtonComponent = {
  <C extends React.ElementType>(
    props: ChipProps<C, { component?: C }> &
      ColoredCommonProps & { noShadow?: boolean; pointer?: boolean }
  ): JSX.Element;
};

export const ColoredChipIconButton = withStyles((theme: Theme) => ({
  label: {
    paddingLeft: 0,
  },
  icon: ({ colored }) => ({
    color: colored && theme.palette.getContrastText(colored),
  }),
  root: ({ noShadow, colored, pointer, coloredHover = colored }: Record<string, any>) => ({
    backgroundColor: colored && colored,
    cursor: pointer && 'pointer',
    boxShadow:
      !noShadow &&
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    '&:hover': {
      backgroundColor: coloredHover && colored,
    },
  }),
}))(
  forwardRef(({ colored, coloredHover, pointer, noShadow, ...props }: any, ref) => (
    <Chip ref={ref} {...props} />
  ))
) as ColoredChipIconButtonComponent;
